import request from '@/utils/request'


export function login(phone, password) {
  return request({
    url: '/login/do', method: 'post', data: {
      phone, password
    }
  })
}

export function logout(param) {
  return request({
    url: '/login/logout', method: 'get', params: param
  })
}


export function fetchList(params) {
  return request({
    url: '/admin/list', method: 'post', params: params
  })
}

export function getInfo(params) {
  return request({
    url: '/admin/info', method: 'get', params: params
  })
}


export function addOrUpdate(data, params) {
  return request({
    url: '/admin/add/or/update', method: 'post', data: data, params: params
  })
}

export function deleteAdmin(id, params) {
  return request({
    url: '/admin/del/' + id, method: 'get', params: params
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id, method: 'post', params: params
  })
}

export function updateRole(id, params) {
  return request({
    url: '/admin/updateRole/' + id, method: 'post', params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/collection/login.js